uvex-spinner {
  visibility: hidden;
  z-index: 1060;
}
uvex-spinner:not(.active) {
  visibility: hidden;
}
uvex-spinner:not(.inline),
uvex-spinner .spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
uvex-spinner.inline {
  position: relative;
  display: flex;
  justify-content: center;
}
uvex-spinner.active, uvex-spinner.active:not(.inline) .spinner-overlay {
  visibility: visible;
  opacity: 1;
}
uvex-spinner .spinner-overlay {
  display: block;
  visibility: hidden;
  opacity: 0.01;
  background: rgba(0, 0, 0, 0.7);
  transition: opacity 0.45s cubic-bezier(0.3, 0, 0.15, 1), visibility 0.45s linear;
}
uvex-spinner svg {
  display: block;
  width: 2rem;
  height: 2rem;
  animation: rotator 1.4s linear infinite;
}
uvex-spinner:not(.inline) svg {
  position: fixed;
  z-index: 1;
  width: 4rem;
  height: 4rem;
  top: calc(50% - 32px);
  left: calc(50% - 32px);
}
@keyframes rotator {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(270deg);
  }
}
uvex-spinner circle {
  stroke-dasharray: 187;
  stroke-dashoffset: 0;
  transform-origin: center;
  animation: dash 1.4s ease-in-out infinite;
  fill: none;
  stroke: var(--brand-primary, #FF6600);
}
@keyframes dash {
  0% {
    stroke-dashoffset: 187;
  }
  50% {
    stroke-dashoffset: 46.75;
    transform: rotate(135deg);
  }
  100% {
    stroke-dashoffset: 187;
    transform: rotate(450deg);
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  uvex-spinner circle {
    stroke-dasharray: 150;
  }
}